(() => {
  document.querySelectorAll('[data-sc-recent]').forEach(async section => {
    if (section.dataset.loaded) return;
    section.dataset.loaded = 'true';
    const current = section.dataset.handle;
    let history;
    try {
      history = JSON.parse(localStorage.getItem('sc-recent') || '[]');
      if (!Array.isArray(history)) history = [];
      history = history.filter(h => typeof h === 'string' && /^[a-z0-9-]+$/.test(h));
      if (current) localStorage.setItem('sc-recent', JSON.stringify([current, ...history.filter(h => h !== current)].slice(0, 12)));
    } catch { return; }
    const load = async () => {
    const root = section.dataset.root.replace(/\/?$/, '/');
    const responses = await Promise.allSettled(history.filter(h => h !== current).slice(0, 4).map(async h => {
      const r = await fetch(root + 'products/' + encodeURIComponent(h) + '.js');
      if (!r.ok) return null;
      return r.json();
    }));
    for (const response of responses) {
      if (response.status !== 'fulfilled' || !response.value) continue;
      const p = response.value;
      const a = document.createElement('a');
      a.href = root + 'products/' + encodeURIComponent(p.handle);
      if (p.featured_image) {
        const img = document.createElement('img'); const imageUrl = new URL(p.featured_image, window.location.origin); imageUrl.searchParams.set('width', '600'); img.src = imageUrl.href; img.decoding = 'async'; img.alt = p.title; img.loading = 'lazy'; img.width = 400; img.height = 400; a.append(img);
      }
      const h = document.createElement('h3'); h.textContent = p.title; a.append(h);
      section.querySelector('.sc-recent__grid').append(a);
    }
    section.hidden = !section.querySelector('.sc-recent__grid').childElementCount;
    };
    if (!history.some(handle => handle !== current)) return;
    const schedule = () => {
      if ('requestIdleCallback' in window) window.requestIdleCallback(() => load(), { timeout: 1500 });
      else setTimeout(load, 0);
    };
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) { observer.disconnect(); schedule(); }
      }, { rootMargin: '400px' });
      observer.observe(section.closest('[data-sc-recent-trigger]'));
    } else schedule();
  });
})();
